/**
 * @file: 层高、离地高度更新计算
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import FrontCubeData from '../../frontCubeData/index';
import { cubeModify } from '../../update/cubeModify';
import { layerHeightCompute } from './computeLayerHeight';
import { shelfChildSortByPosition } from './childSortByPosition';
import { layerYRectify } from './layerYRectify';

const whiteListRelationType = [
    'layer-shelf',
    'beam-shelf',
    'dishrack-shelf',
    'roof-shelf'
];

// 更新所有货架的层高值
function allShelfsLayerHeight() {
    let shelfs: Array<CubeId> = CubeTree.getCubeByType('shelf');

    shelfs.forEach((shelf: CubeId): void => {
        targetShelfsLayerHeight(shelf);
    });
}

// 更新指定货架层高值
function targetShelfsLayerHeight(shelf: CubeId): void {
    let layers: Array<CubeId> = CubeTree.findChildCubeIds(shelf);

    layers.forEach((layer: CubeId): void => {
        updateTargetLayer(layer);
    });
}

function updateTargetLayer(layer: CubeId): void {
    if (!shouldUpdateLayerHeight(layer)) {
        return;
    }

    let currentCubePosY: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'posY');
    let layerHeight: PhysicsMeasurement = layerHeightCompute(layer);

    cubeModify(layer, {
        layerHeight: layerHeight,
        floorHeight: currentCubePosY
    });
}

function shouldUpdateLayerHeight(layer: CubeId): boolean {
    let parentCube: CubeNode = CubeTree.findParentCubeByCubeId(layer);
    let cubeRelationType: string = CubeTree.cubeRelationType([layer, parentCube.id]);

    return whiteListRelationType.includes(cubeRelationType);
}

export {
    allShelfsLayerHeight,
    targetShelfsLayerHeight,
    shelfChildSortByPosition,
    layerYRectify
};
